// Constants
export const LOYALTY_STATUS = {
    ELIGIBLE: "eligible",
    INELIGIBLE: "ineligible",
} as const;

// Types
export type LoyaltyStatus = (typeof LOYALTY_STATUS)[keyof typeof LOYALTY_STATUS];

export interface BannerMessage {
    text: string;
    subText: string;
}

export interface IneligiblePayload {
    text: string;
    subText: string;
    bannerMessage: BannerMessage;
}

export interface LoyaltyScanResponse {
    data: {
        Text: string;
        subText: string;
        statusCode: number;
        bannerMessage: {
            Text: string;
            subText: string;
        };
    };
}

// Status code mapping
export const STATUS_CODE = {
    ELIGIBLE: 0,
} as const;

export const ANALYTICS_CATEGORY = {
    DO_CLAIM_CASHBACK: "DO-Claim-Cashback",
} as const;

export const ANALYTICS_ACTION = {
    TAP_TO_CLAIM: "tap-to-claim",
    EXPLORE: "explore",
    DOWNLOAD_APP: "download-app",
    LOGIN: "login",
} as const;

export const ANALYTICS_LABEL = {
    TAP_TO_CLAIM_CLICK: "tap-to-claim-click",
    EXPLORE_IMPRESSION: "explore-imp",
    EXPLORE_CLICK: "explore-click",
    DOWNLOAD_APP_CLICK: "download-app-click",
    LOGIN_CLICK: "login-click",
} as const;
